<template>
  <div class="container-input-filtros">
    <i class="fa fa-search icn-search"></i>
    <input
      :value="text"
      class="ipt-search"
      @input="onInput"
      type="text"
      :placeholder="filtro.placeholder"
    />
    <SettingAdvanced
      v-if="filtro.advanced"
      :campo="filtro"
      @update:advancedSetting="onUpdateAdvancedSetting"
    />
  </div>
</template>
<script>
import SettingAdvanced from './SettingAdvanced.vue';
export default {
  props: {
    filtro: {
      type: Object,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  emits: ['aplicarFiltro', 'update:text'],
  components: {
    SettingAdvanced
  },
  data() {
    return {
      debounceTimeout: null
    };
  },
  methods: {
    onInput(event) {
      this.$emit('update:text', event.target.value);

      clearTimeout(this.debounceTimeout);
      this.debounceTimeout = setTimeout(() => this.$emit('aplicarFiltro'), 1000);
    },
    async onUpdateAdvancedSetting(value) {
      try {
        const filtros = await this.$filtroDb.recuperarFiltros(this.path);
        const filtroIndex = filtros.findIndex(f => f.filtro === this.filtro.filtro);
        if (filtroIndex !== -1) {
          filtros[filtroIndex].advancedSetting = value;
        } else {
          filtros.push({ ...this.filtro, advancedSetting: value });
        }
        await this.$filtroDb.salvarFiltros(this.path, filtros);
      } catch (error) {
        exibe_erro('Erro ao salvar preferência avançada de filtragem');
      }

      if (this.text.length > 0) {
        this.$emit('aplicarFiltro');
      }
    }
  },
  beforeUnmount() {
    clearTimeout(this.debounceTimeout);
  }
}
</script>
